<ul class="list-group">
<ng-container *ngFor="let website of websites">
  <app-components-specialist-boost-site-account-read-only [website]="website" class="list-group-item">
  </app-components-specialist-boost-site-account-read-only>
</ng-container>
</ul>